import { ConfirmDialog } from "@avenue-8/sidekick-ui";
import { useUIStore } from "@cma/store/ui.store";

export const ChatWidgetConfirmDialog = () => {
  const chatWidgetConfirmDialogState = useUIStore(
    (state) => state.chatWidgetConfirmDialogState
  );

  return (
    <ConfirmDialog
      open={chatWidgetConfirmDialogState?.resolve != null}
      dialogTitle={chatWidgetConfirmDialogState?.title}
      onCancel={
        chatWidgetConfirmDialogState?.cancelButtonText === false
          ? undefined
          : () => chatWidgetConfirmDialogState?.resolve?.(false)
      }
      onConfirm={() => chatWidgetConfirmDialogState?.resolve?.(true)}
      dialogContent={chatWidgetConfirmDialogState?.content}
      confirmLabel={chatWidgetConfirmDialogState?.confirmButtonText}
      cancelLabel={chatWidgetConfirmDialogState?.cancelButtonText}
      maxWidth={chatWidgetConfirmDialogState.maxWidth}
      fullWidth={chatWidgetConfirmDialogState.fullWidth}
    />
  );
};
